module.exports = __webpack_public_path__ + "assets/img/FormPiper-Landing-Page-+-Website-w960.b4917ca0.webp";